import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/** Listado de versiones de presupuesto por obra (bi.fact_presupuesto). */
export function usePresupuestos(worksNo?: string) {
  return useQuery({
    queryKey: ['presupuestos', worksNo ?? null],
    queryFn: () => cliente.presupuestos.listar(worksNo),
    staleTime: 5 * 60_000,
  });
}

/** Detalle de una versión (resumen por grupo + partidas). */
export function usePresupuestoDetalle(worksNo: string | null, version?: string) {
  return useQuery({
    queryKey: ['presupuesto', worksNo, version ?? null],
    queryFn: () => cliente.presupuestos.detalle(worksNo ?? '', version),
    enabled: !!worksNo,
    staleTime: 5 * 60_000,
  });
}
